import type { SvgProps } from "@/utils/svg-wrapper";

import React from "react";

import { Svg } from "@/utils/svg-wrapper";

export const ArrowDropdownIcon: React.FC<SvgProps> = ({ className }) => (
  <Svg className={className} fill="none" height="16" viewBox="0 0 16 16" width="16">
    <path
      d="M12.6663 10L8.94244 13.6203C8.42392 14.1266 7.57543 14.1266 7.05691 13.6203L3.33301 10"
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
    <path
      d="M12.6663 6L8.94244 2.37971C8.42392 1.87343 7.57543 1.87343 7.05691 2.37971L3.33301 6"
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
    />
  </Svg>
);
